import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { formatJSON } from '../../utils'
import { selectChainInfo } from '../../store/reducers/chain'
import { getHeadStoreInfoSession } from '../../utils/session/store'

// import MaxKBChatBot from '../MaxKBChatBot'
import ZapierChatbot from '../ZapierChatbot'

const GlobalChatbot = () => {
  const [chainInfo, setChainInfoState] = useState(null)
  const reduxChainInfo = useSelector(selectChainInfo)

  useEffect(() => {
    // 优先使用 Redux 中的数据，否则从 localStorage 获取
    const info = reduxChainInfo || getHeadStoreInfoSession()
    setChainInfoState(info)
  }, [reduxChainInfo])

  if (!chainInfo) return null

  const { extendColumn, extendColumn1 } = chainInfo
  const extendData = formatJSON(extendColumn) || {}
  const extendData1 = formatJSON(extendColumn1) || {}

  const shouldShowChatbot = extendData?.isCheckAIAssistant && 
                           extendData1?.isOpenAiChat && 
                           extendData1?.aiChatType === 2

  return shouldShowChatbot ? <ZapierChatbot chatbotId={extendData1.key} /> : null

  // const shouldShowChatbot = true

  // return shouldShowChatbot ? <MaxKBChatBot chatbotId={'b7a772047267331c'} /> : null
}

export default GlobalChatbot